import { EARNING_TIERS } from "commons/earnings.constants";
import { formatInr, formatCount } from "services/earnings.service";

/**
 * The four earning tiers, with the community's current tier marked.
 *
 * Deliberately does NOT show distance to the next tier. The share of fee steps
 * hard at each boundary (10% to 20% at 801 members), so a "you're 6 members
 * away" prompt would coach partners into inflating member lists. Showing the
 * ladder is honest; coaching the jump is not — revisit once the tier policy is
 * settled.
 */
function TierLadder({ activeTierId, className = "" }) {
  return (
    <div className={`grid gap-3 sm:grid-cols-2 lg:grid-cols-4 ${className}`}>
      {EARNING_TIERS.map((tier) => {
        const isActive = tier.id === activeTierId;
        const range = tier.maxMembers
          ? `${formatCount(Math.max(tier.minMembers, 50))} – ${formatCount(tier.maxMembers)}`
          : `${formatCount(tier.minMembers)}+`;

        return (
          <div
            key={tier.id}
            className={`rounded-2xl border p-5 transition-colors ${
              isActive
                ? "border-[hsl(var(--brand-coral))] bg-[hsl(var(--brand-coral)/0.07)]"
                : "border-border/60 bg-card"
            }`}
          >
            <div className="flex items-baseline justify-between gap-2">
              <span
                className={`font-display text-base font-semibold tracking-tight ${
                  isActive ? "text-[hsl(var(--brand-coral))]" : "text-foreground"
                }`}
              >
                {tier.name}
              </span>
              <span className="font-display text-xl font-bold tabular-nums text-foreground">
                {Math.round(tier.share * 100)}%
              </span>
            </div>

            <p className="mt-1 text-xs tabular-nums text-muted-foreground">
              {range} members
            </p>

            <p className="mt-3 border-t border-border/50 pt-3 text-xs text-muted-foreground">
              Bonus up to{" "}
              <span className="font-semibold tabular-nums text-foreground">
                {formatInr(tier.bonusMax)}
              </span>
              /mo
            </p>
          </div>
        );
      })}
    </div>
  );
}

export default TierLadder;
